import React, { useEffect, useRef, useState } from "react";
import { API } from "../../../../../../../services/api-services";
import { RestOperator } from "../../../../../../cold-start/models/model";
import FetchData from "../../../../../../shared/fetch-data/fetch-data";
import { ImagePlayerAction } from "../../../modal/funUGCModal.component";
import styles from "./ImageProgressControl.module.scss";

interface ImageProgressControlProps {
  imageState: ImagePlayerAction;
  setImageState: React.Dispatch<React.SetStateAction<ImagePlayerAction>>;
  onNext: () => void;
}

export function ImageProgressControl({
  imageState,
  setImageState,
  onNext
}: ImageProgressControlProps) {
  const [imageDuration, setImageDuration] = useState<number | null>(5000);
  const [isPaused, setIsPaused] = useState<boolean>();
  const trackEl = useRef<HTMLDivElement>();

  useEffect(() => {
    if (imageState === "Loading") {
      setIsPaused(true);
      setImageState("Loading");
    } else if (imageState === "Pause") {
      setIsPaused(true);
      setImageState("Pause");
    } else if (imageState === "Play") {
      setIsPaused(false);
      setImageState("Play");
    }
  }, [imageState, setImageState]);

  useEffect(() => {
    const track = trackEl.current;
    const duration = imageDuration;
    track.style.animationDuration = `${duration}ms`;
    track.style.animationPlayState = isPaused ? "paused" : "running";

    // Add event listener for animation end
    track.addEventListener("animationend", handleAnimationEnd);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      track.removeEventListener("animationend", handleAnimationEnd);
    };
  }, [imageDuration, isPaused]);

  const handleAnimationEnd = () => {
    onNext();
  };

  return (
    <>
      <FetchData
        url={API.request_rest_operator}
        method="GET"
        onSuccessful={data => {
          const newData = data as RestOperator;
          setImageDuration(newData.json_content.fun_coloring_painting_time);
        }}
        with_dg_id
        unAuthorized={true}
      />

      <div className={styles.progressSlider}>
        <div className={styles.background} />
        <div className={styles.track} ref={trackEl} />
      </div>
    </>
  );
}
